import { responsiveMap, } from 'antd/lib/_util/responsiveObserve';
var Breakpoints = Object.entries(responsiveMap).reduce(function (accumulator, currentItem) {
    var breakpointName = currentItem[0], breakpointValue = currentItem[1];
    var result = breakpointValue.match(/[0-9]*px/g);
    if (result) {
        var breakpointValueInPx = result[0];
        accumulator[breakpointName] = breakpointValueInPx;
    }
    return accumulator;
}, {});
export { Breakpoints };
//# sourceMappingURL=breakpoints.js.map